export enum TemaIconeModalConfirmacao {
  azul = 'azul',
  vermelho = 'vermelho',
  verde = 'verde',
  laranja = 'laranja',
}
